// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1RRzS","header":"MessagesList_header__Je2Mx","chat":"MessagesList_chat__2j988"};